import { CustomiseSections } from '../../common/enum/CustomiseSections';

export const CustomiseCategoriesIds: { [key: string]: string } = {
  [CustomiseSections.VARIANT]: 'variant',
  [CustomiseSections.INTERIOR]: 'interior',
  [CustomiseSections.EXTERIOR]: 'colour',
  [CustomiseSections.ACCESSORY]: 'accessories',
  [CustomiseSections.PACKS]: 'options',
  [CustomiseSections.SERVICE_PLAN]: 'service',
  [CustomiseSections.SUMMARY]: 'summary',
  [CustomiseSections.SELECTIONS]: 'selections',
  [CustomiseSections.STOCK]: 'stock',
};
